/**
 * @generated SignedSource<<d00a0d88c95a75af47deff3fe796d84c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceTodoEditMainSubscription$variables = {
  todoWorkspaceId: string;
  workspaceId: string;
};
export type WorkspaceTodoEditMainSubscription$data = {
  readonly todoWorkspaceChanged: {
    readonly formattedBody: string | null;
    readonly id: string;
    readonly parent: {
      readonly __typename: "TodoWorkspace";
      readonly title: string;
    } | null;
    readonly publishedAtDate: {
      readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
    } | null;
    readonly status: WorkspaceTodoStatus;
    readonly updatedBySessionId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRecieversListItemButton_workspaceEntity" | "WorkspaceTodoEditMainContent_Todo" | "WorkspaceTodoEditMainEditedInfo_Todo" | "WorkspaceTodoEditMainExpireSelector_Todo" | "WorkspaceTodoEditMainPrioritySelector_Todo" | "WorkspaceTodoEditMainPushNotification_todoWorkspace" | "WorkspaceTodoEditMainResponseType_TodoWorkspace" | "WorkspaceTodoEditMainSubTodos_todoWorkspace">;
  } | null;
};
export type WorkspaceTodoEditMainSubscription = {
  response: WorkspaceTodoEditMainSubscription$data;
  variables: WorkspaceTodoEditMainSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "todoWorkspaceIds.0",
        "variableName": "todoWorkspaceId"
      }
    ],
    "kind": "ListValue",
    "name": "todoWorkspaceIds"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBySessionId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedBody",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v16 = [
  (v3/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = [
  (v3/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v22 = [
  (v8/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspaceChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "publishedAtDate",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormattedDate"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainSubTodos_todoWorkspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainPrioritySelector_Todo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainEditedInfo_Todo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainContent_Todo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainExpireSelector_Todo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainResponseType_TodoWorkspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoEditMainPushNotification_todoWorkspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceRecieversListItemButton_workspaceEntity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspaceChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "publishedAtDate",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v10/*: any*/),
                "type": "Date",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "subWorkspaceTodos",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "descriptionImages",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "descriptionFiles",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceProduct",
                "kind": "LinkedField",
                "name": "linkedProducts",
                "plural": true,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "updatedAtDate",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "publishedBy",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v19/*: any*/),
              (v17/*: any*/),
              (v12/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FilePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "thumbnail",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendNotificationAtPublish",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "receiverStores",
                "plural": true,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "WorkspaceEntity",
            "abstractKey": "__isWorkspaceEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c09a5968e7b45814a1b8762a4374dcff",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainSubscription",
    "operationKind": "subscription",
    "text": "subscription WorkspaceTodoEditMainSubscription(\n  $workspaceId: ID!\n  $todoWorkspaceId: ID!\n) {\n  todoWorkspaceChanged(todoWorkspaceIds: [$todoWorkspaceId], workspaceId: $workspaceId) {\n    id\n    status\n    publishedAtDate {\n      ...FormattedDate\n    }\n    updatedBySessionId\n    formattedBody\n    parent {\n      title\n      __typename\n      id\n    }\n    ...WorkspaceTodoEditMainSubTodos_todoWorkspace\n    ...WorkspaceTodoEditMainPrioritySelector_Todo\n    ...WorkspaceTodoEditMainEditedInfo_Todo\n    ...WorkspaceTodoEditMainContent_Todo\n    ...WorkspaceTodoEditMainExpireSelector_Todo\n    ...WorkspaceTodoEditMainResponseType_TodoWorkspace\n    ...WorkspaceTodoEditMainPushNotification_todoWorkspace\n    ...WorkspaceRecieversListItemButton_workspaceEntity\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_files on File {\n  ...LinkedContent_files\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_files on File {\n  id\n  name\n  type\n  url\n  ...LinkedFileItem_file\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedFileItem_file on File {\n  id\n  name\n  ...FileIcon_File\n  pages {\n    id\n  }\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment ListItemDescriptionContentFiles_files on File {\n  id\n  ...FileIconBox_file\n}\n\nfragment ListItemDescriptionContentProducts_products on WorkspaceProduct {\n  id\n  ...WorkspaceTodoListItemProducts_WorkspaceProduct\n}\n\nfragment ListItemDescriptionContent_images on Image {\n  id\n  ...Image_image\n}\n\nfragment WorkspaceRecieversListItemButton_workspaceEntity on WorkspaceEntity {\n  __isWorkspaceEntity: __typename\n  potentialReceiverStores {\n    __typename\n    id\n  }\n  receiverStores {\n    __typename\n    id\n  }\n  topic {\n    name\n    id\n  }\n}\n\nfragment WorkspaceTodoEditMainContent_Todo on TodoWorkspace {\n  id\n  title\n  body\n  publishedAtDate {\n    ...FormattedDate\n  }\n  publishedBy {\n    id\n    name\n  }\n  formattedBody\n  updatedBySessionId\n  ...WorkspaceTodoLinkedContent_todo\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceTodoEditMainExpireSelector_Todo on TodoWorkspace {\n  id\n  updatedBy {\n    id\n    name\n  }\n  expireAtDate {\n    isoString\n  }\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n}\n\nfragment WorkspaceTodoEditMainPrioritySelector_Todo on TodoWorkspace {\n  id\n  priority\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n}\n\nfragment WorkspaceTodoEditMainPushNotification_todoWorkspace on TodoWorkspace {\n  id\n  sendNotificationAtPublish\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceTodoEditMainResponseType_TodoWorkspace on TodoWorkspace {\n  id\n  responseType\n  responseDescription\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceTodoEditMainSubTodos_todoWorkspace on TodoWorkspace {\n  id\n  subWorkspaceTodos {\n    id\n    title\n    ...WorkspaceTodoListItemDescription_todo\n    priority\n  }\n}\n\nfragment WorkspaceTodoLinkedContent_todo on TodoWorkspace {\n  id\n  descriptionImages {\n    id\n    ...LinkedContentInput_images\n  }\n  descriptionFiles {\n    id\n    ...LinkedContentInput_files\n  }\n}\n\nfragment WorkspaceTodoListItemDescription_todo on TodoWorkspace {\n  title\n  descriptionImages {\n    ...ListItemDescriptionContent_images\n    id\n  }\n  descriptionFiles {\n    ...ListItemDescriptionContentFiles_files\n    id\n  }\n  linkedProducts {\n    ...ListItemDescriptionContentProducts_products\n    id\n  }\n}\n\nfragment WorkspaceTodoListItemProducts_WorkspaceProduct on WorkspaceProduct {\n  name\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "1c9f1fb1c526e4c1eadebbcfb15a7185";

export default node;
